import { TimePicker } from './time-picker.component';

export * from './time-picker.component';
export default TimePicker;

TimePicker.define('der-tailormade-appointment-booking-time-picker');

declare global {
    interface HTMLElementTagNameMap {
        'der-tailormade-appointment-booking-time-picker': TimePicker;
    }
}
